import React, { useCallback, useContext, useEffect, useState } from "react"; // Adicione useEffect
import ModalContext from '../../../../contexts/ModalContext'
import { ActionsDiv, CloseButton, CloseDiv, CloseImg, Container, Employees, HalfButton, HeaderDiv, HeaderText, InfoProduction, InfoText, ItemsTable, Labor, NameInfo, PlayButton, Select, Separator, StatusProduction, TableInfo, TableInfoText, TableText, TableTitle, TimeProduction } from "./style";
import cross from '../../../../assets/addStockModal/cross.svg'
import arrowDown from '../../../../assets/addStockModal/excel/arrow-down.svg'
import halfOP from '../../../../assets/fashion/Actions/half-op.svg'
import play from '../../../../assets/fashion/Actions/white-play.svg'
import FashionApiService from '../../../../services/FashionApiService';
import eventBus from "../../../../utils/eventBus";
import { FashionProductionOrderData, FashionProductionItemsData } from "../FashionPcp";

// Re-importe as interfaces ou certifique-se de que estão disponíveis globalmente
// Se elas estão definidas em ProductionFashionTable.tsx, você pode importá-las de lá:


const ViewProductionFashion = () => {
    // Pegue selectedProductionOrder do contexto
    const { setModalActive, setSelectedProductionOrder, selectedProductionOrder } = useContext(ModalContext)
    
    // Estados locais para as listas de cortadores e costureiras DENTRO DO MODAL
    const [cuttersList, setCuttersList] = useState<any[]>([]);
    const [dressmakersList, setDressmakersList] = useState<any[]>([]);
    // Adicione um estado para o erro e loading, já que você tem uma fetchData aqui
    const [isLoadingUsers, setIsLoadingUsers] = useState(true);
    const [errorUsers, setErrorUsers] = useState<string | null>(null);
     // --- NOVO ESTADO: Para rastrear se HOUVE ALTERAÇÕES no modal ---
    const [hasChanges, setHasChanges] = useState(false);
    // --- FIM NOVO ESTADO ---

    // fetchData para buscar apenas os usuários, já que as OPs vêm pelo contexto
    const fetchUsersData = useCallback(async () => { // Renomeado para evitar conflito e ser mais claro
        try {
            setIsLoadingUsers(true);
            setErrorUsers(null);

            // Buscar diretamente no backend por role para garantir filtro por tenant
            const [cuttersResp, dressmakersResp] = await Promise.all([
                FashionApiService.getUsers('Cortador'),
                FashionApiService.getUsers('Costureira')
            ]);

            const cutters = cuttersResp.data || [];
            const dressmakers = dressmakersResp.data || [];

            setCuttersList([{ id: 0, name: "Selecione..." }, ...cutters]);
            setDressmakersList([{ id: 0, name: "Selecione..." }, ...dressmakers]);

        } catch (err: any) {
            console.error('Erro ao buscar usuários para o modal:', err);
            setErrorUsers('Falha ao carregar lista de usuários.');
        } finally {
            setIsLoadingUsers(false);
        }
    }, []); // Array de dependências vazio, pois não depende de props/estados voláteis

    // Use useEffect para chamar fetchData quando o componente montar
    useEffect(() => {
        fetchUsersData();
    }, [fetchUsersData]);


    // Se não houver ordem de produção selecionada, mostre um placeholder
    if (!selectedProductionOrder) {
        return (
            <Container>
                <HeaderDiv>
                    <HeaderText>Detalhes da Ordem de Produção</HeaderText>
                    <CloseDiv onClick={() => {
                        setModalActive(false);
                        setSelectedProductionOrder(null);
                    }}>
                        <CloseImg src={cross} alt='Fechar aba'/>
                    </CloseDiv>
                </HeaderDiv>
                <InfoProduction>
                    <InfoText>Nenhuma ordem de produção selecionada para visualização/edição.</InfoText>
                </InfoProduction>
            </Container>
        );
    }

    // Funções de atualização para o cortador e costureira (AGORA DENTRO DO MODAL)
    const handleCortadorChangeModal = async (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedUserId = Number(e.target.value);
        const orderId = selectedProductionOrder.id; // Use selectedProductionOrder.id
        const selectedUserObject = cuttersList.find(c => c.id === selectedUserId);
        
        // Atualização otimista na UI do modal
        setSelectedProductionOrder((prevOrder:any) => {
            if (!prevOrder) return null;
            return {
                ...prevOrder,
                cutterId: selectedUserId === 0 ? null : selectedUserId,
                cutter: selectedUserId === 0 ? undefined : selectedUserObject 
            };
        });

        try {
            await FashionApiService.updateProductionOrder(orderId, {
                cutterId: selectedUserId === 0 ? null : selectedUserId,
            });
            const newCutterName = selectedUserObject?.name || 'Nenhum';
            alert(`SUCESSO: Cortador da OP-${orderId} atualizado para ${newCutterName} (via modal)!`);
            setHasChanges(true)
        } catch (err) {
            console.error(`Erro ao atualizar cortador da OP ${orderId} (via modal):`, err);
            alert(`ERRO: Falha ao atualizar cortador da OP-${orderId} (via modal). Verifique o console.`);
            // Em caso de erro, você pode querer reverter a alteração no selectedProductionOrder
            // ou simplesmente recarregar a lista de usuários ou a página inteira para garantir consistência.
            // Para simplicidade de teste, vou manter o alert.
            // Para uma aplicação real, você pode querer chamar fetchUsersData() novamente,
            // ou até mesmo um callback para que a tabela principal possa recarregar suas OPs.
        }
    };

    const handleCostureiraChangeModal = async (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedUserId = Number(e.target.value);
        const orderId = selectedProductionOrder.id; // Use selectedProductionOrder.id
        const selectedUserObject = dressmakersList.find(d => d.id === selectedUserId);

        // Atualização otimista na UI do modal
        setSelectedProductionOrder((prevOrder:any) => {
            if (!prevOrder) return null;
            return {
                ...prevOrder,
                dressmakerId: selectedUserId === 0 ? null : selectedUserId,
                dressmaker: selectedUserId === 0 ? undefined : selectedUserObject
            };
        });

        try {
            await FashionApiService.updateProductionOrder(orderId, {
                dressmakerId: selectedUserId === 0 ? null : selectedUserId,
            });
            const newDressmakerName = selectedUserObject?.name || 'Nenhum';
            alert(`SUCESSO: Costureira da OP-${orderId} atualizada para ${newDressmakerName} (via modal)!`);
            setHasChanges(true)
        } catch (err) {
            console.error(`Erro ao atualizar costureira da OP ${orderId} (via modal):`, err);
            alert(`ERRO: Falha ao atualizar costureira da OP-${orderId} (via modal). Verifique o console.`);
            // Em caso de erro, similar ao acima.
        }
    };

     // --- FUNÇÃO DE FECHAMENTO DO MODAL ---
    const handleCloseModal = () => {
        setModalActive(false); // Fecha o modal via contexto
        setSelectedProductionOrder(null); // Limpa a ordem selecionada no contexto
        
        // --- NOVO: Dispara o evento de refresh APENAS SE HOUVE MUDANÇAS ---
        if (hasChanges) {
            eventBus.emit('refreshProductionTable'); // Emite o evento que a tabela está ouvindo
        } else {
            console.log('Modal fechado sem alterações visíveis.');
        }
    };

    if (isLoadingUsers) {
        return (
            <Container>
                <HeaderDiv>
                    <HeaderText>Carregando Usuários...</HeaderText>
                    <CloseDiv onClick={() => setModalActive(false)}>
                        <CloseImg src={cross} alt='Fechar aba'/>
                    </CloseDiv>
                </HeaderDiv>
                <InfoProduction>
                    <InfoText>Aguarde enquanto carregamos a lista de cortadores e costureiras.</InfoText>
                </InfoProduction>
            </Container>
        );
    }

    if (errorUsers) {
        return (
            <Container>
                <HeaderDiv>
                    <HeaderText>Erro ao Carregar Usuários</HeaderText>
                    <CloseDiv onClick={() => setModalActive(false)}>
                        <CloseImg src={cross} alt='Fechar aba'/>
                    </CloseDiv>
                </HeaderDiv>
                <InfoProduction>
                    <InfoText>Ocorreu um erro: {errorUsers}. Por favor, tente novamente.</InfoText>
                </InfoProduction>
            </Container>
        );
    }


    return (
        <Container>
            <HeaderDiv>
                <HeaderText>
                    Ordem de Produção OP-{selectedProductionOrder.id}
                </HeaderText>
                <CloseDiv onClick={handleCloseModal}>
                    <CloseImg src={cross} alt='Fechar aba'/>
                </CloseDiv>
            </HeaderDiv>
            <InfoProduction>
                <StatusProduction>
                    <NameInfo>Status</NameInfo>
                    <InfoText>{selectedProductionOrder.status}</InfoText>
                </StatusProduction>
                <TimeProduction>
                    <NameInfo>Tempo estimado</NameInfo>
                    <InfoText>1h23m45s</InfoText> 
                </TimeProduction>
            </InfoProduction>
            <Separator />
            <InfoProduction>
                <StatusProduction>
                    <NameInfo>Produto</NameInfo>
                    <InfoText>{selectedProductionOrder.fashionProduct?.name || 'N/A'}</InfoText>
                </StatusProduction>
                <StatusProduction>
                    <NameInfo>Referência</NameInfo>
                    <InfoText>PROD123A</InfoText> 
                </StatusProduction>
            </InfoProduction>
            <InfoProduction>
                <StatusProduction>
                    <NameInfo>Quantidade de itens</NameInfo>
                    <InfoText>{selectedProductionOrder.totalItems || 0}</InfoText>
                </StatusProduction>
                <StatusProduction>
                    <NameInfo>Cor</NameInfo>
                    <InfoText>{selectedProductionOrder.color?.name || 'N/A'}</InfoText>
                </StatusProduction>
            </InfoProduction>
            <Labor>
                <Employees>
                    <InfoText>Cortador</InfoText>
                    <Select
                        value={selectedProductionOrder.cutterId || 0} 
                        onChange={handleCortadorChangeModal} // Chamando a função do modal
                        className="p-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        {cuttersList.map((cutter) => (
                            <option key={cutter.id} value={cutter.id}>
                                {cutter.name}
                            </option>
                        ))}
                    </Select>
                    {/* <img style={{ marginLeft: '-2rem', pointerEvents: 'none' }} src={arrowDown} alt="Seta para baixo" /> */}
                </Employees>
                <Employees>
                    <InfoText>Costureira</InfoText>
                    <Select
                        value={selectedProductionOrder.dressmakerId || 0} 
                        onChange={handleCostureiraChangeModal} // Chamando a função do modal
                        className="p-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        {dressmakersList.map((dressmaker) => (
                            <option key={dressmaker.id} value={dressmaker.id}>
                                {dressmaker.name}
                            </option>
                        ))}
                    </Select>
                    {/* <img style={{ marginLeft: '-2rem', pointerEvents: 'none' }} src={arrowDown} alt="Seta para baixo" /> */}
                </Employees>
            </Labor>
            <ItemsTable>
                <InfoText>Itens</InfoText>
                <TableTitle>
                    <TableText >Pedidos</TableText>
                    <TableText >Cliente</TableText> 
                    <TableText >Qtd.</TableText>
                </TableTitle>
                {selectedProductionOrder.fashionProductionItems && selectedProductionOrder.fashionProductionItems.length > 0 ? (
                    selectedProductionOrder.fashionProductionItems.map((item: FashionProductionItemsData | any) => (
                        <TableInfo key={item.id}>
                            <TableInfoText >PED-{item.fashionOrderId}</TableInfoText>
                            <TableInfoText >{item.fashionOrder?.company?.companyName || 'N/A'}</TableInfoText> 
                            <TableInfoText >{item.quantityForThisProduction}</TableInfoText>
                        </TableInfo>
                    ))
                ) : (
                    <InfoText>Nenhum item associado a esta ordem de produção.</InfoText>
                )}
            </ItemsTable>
            <ActionsDiv>
                <div>
                    <CloseButton onClick={handleCloseModal}>Fechar</CloseButton>
                </div>
                <div>
                    <HalfButton><img src={halfOP} alt="Dividir OP" />Dividir OP</HalfButton>
                </div>
                <div>
                    <PlayButton><img src={play} alt="Iniciar produção" />Iniciar produção</PlayButton>
                </div>
            </ActionsDiv>
        </Container>
    )
}

export default ViewProductionFashion;
